"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RadarChart = _interopRequireDefault(require("../../RadarChart/RadarChart"));
var _Dropdown = _interopRequireDefault(require("../../../Dropdown/Dropdown"));
var _DownloadLinkBox = _interopRequireDefault(require("../../DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-delegates-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 52px; }\n  .inapp-delegates-container .inapp-delegates-item {\n    display: flex;\n    flex-direction: column;\n    gap: 48px;\n    width: 500px;\n    max-width: 100%; }\n    .inapp-delegates-container .inapp-delegates-item .downloadlink-container p {\n      width: 100%; }\n    .inapp-delegates-container .inapp-delegates-item .item-list {\n      display: flex;\n      justify-content: flex-start;\n      flex-wrap: wrap;\n      gap: 86px; }\n      .inapp-delegates-container .inapp-delegates-item .item-list .item .number {\n        font-size: 54px; }\n      .inapp-delegates-container .inapp-delegates-item .item-list .item .label {\n        font-size: 14px; }\n      .inapp-delegates-container .inapp-delegates-item .item-list .item .women-color {\n        margin-top: 16px;\n        width: 16px;\n        height: 16px;\n        background-color: #8caddb; }\n      .inapp-delegates-container .inapp-delegates-item .item-list .item .men-color {\n        margin-top: 16px;\n        width: 16px;\n        height: 16px;\n        background-color: #dacd7e; }\n    .inapp-delegates-container .inapp-delegates-item .section-info {\n      display: flex;\n      gap: 48px;\n      justify-content: space-between; }\n    .inapp-delegates-container .inapp-delegates-item .OrganisationMember-container {\n      margin: 0px;\n      max-width: 244px; }\n    .inapp-delegates-container .inapp-delegates-item .right-content {\n      width: 100%; }\n    .inapp-delegates-container .inapp-delegates-item .chart-holder {\n      margin: auto; }\n    .inapp-delegates-container .inapp-delegates-item .list-container {\n      padding-right: 64px; }\n\n@media (max-width: 66rem) {\n  .inapp-delegates-container {\n    grid-template-columns: 1fr; }\n    .inapp-delegates-container .inapp-delegates-item {\n      width: 640px; } }\n";
  const fileName = "InAppDelegates_InAppDelegates";
  const element = document.querySelector("style[data-sass-component='InAppDelegates_InAppDelegates']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const TopContent = _ref => {
  let {
    value,
    setValue,
    translate,
    sections,
    lang,
    label
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-container"
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    id: 'Sektionen',
    label: translate(label),
    items: sections.map(section => ({
      id: section?.id,
      label: section?.label
    })),
    onChange: (event, item) => {
      item.label !== value.label && setValue(item);
    },
    value: value
  }));
};
const min = (a, b) => a < b ? a : b;
const Chart = /*#__PURE__*/_react.default.memo(_ref2 => {
  let {
    ...args
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_RadarChart.default, args);
});
const BottomContent = _ref3 => {
  let {
    selected,
    translate
  } = _ref3;
  const [width, setWidth] = (0, _react.useState)(0);
  const [height, setHeight] = (0, _react.useState)(0);
  const ref = (0, _react.useRef)();
  (0, _react.useEffect)(() => {
    const widthAux = ref?.current ? ref.current.clientWidth : 300;
    setWidth(widthAux);
    setHeight(min(widthAux * 0.75, 350));
  }, []);
  const args = {
    colors: {
      Men: 'SIAyellow',
      Women: 'SIAazure'
    },
    width: `${width}px`,
    height: `${height}px`,
    fillMode: 'low',
    showTotal: true
  };
  const stats = selected?.stats?.section_stats && selected?.stats?.section_stats[0] || selected?.stats?.professional_group_stats && selected?.stats?.professional_group_stats[0];
  const chartItems = _react.default.useMemo(() => {
    if (selected?.stats && Object.entries(selected?.stats).length > 4 && Object.entries(selected?.stats)?.every(el => el[1]?.length > 0)) {
      return {
        Men: Object.fromEntries(Object.entries(selected.stats).filter(_ref4 => {
          let [key, value] = _ref4;
          return !key.includes('section_stats') && !key.includes('professional_group_stats');
        })?.map(_ref5 => {
          let [key, value] = _ref5;
          return [key, value[0].total_men];
        })),
        Women: Object.fromEntries(Object.entries(selected.stats).filter(_ref6 => {
          let [key, value] = _ref6;
          return !key.includes('section_stats') && !key.includes('professional_group_stats');
        })?.map(_ref7 => {
          let [key, value] = _ref7;
          return [key, value[0].total_women];
        }))
      };
    }
    return {};
  }, [selected]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "right-content sia-padding-02-top"
  }, stats && /*#__PURE__*/_react.default.createElement("div", {
    className: "item-list sia-padding-04-bottom"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.total_women + stats.total_men), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate(`cms.inapp.delegates.delegates`))), /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.total_women), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.sections.women')), /*#__PURE__*/_react.default.createElement("div", {
    className: "women-color"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "item"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-14 number"
  }, stats.total_men), /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-11 label"
  }, translate('cms.inapp.sections.men')), /*#__PURE__*/_react.default.createElement("div", {
    className: "men-color"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "chart-container",
    ref: ref,
    style: {
      minHeight: `${height}px`
    }
  }, !!(chartItems?.Men && chartItems?.Women) && height && /*#__PURE__*/_react.default.createElement(Chart, _extends({}, args, {
    items: chartItems
  }))));
};
const InAppDelegatesItem = _ref8 => {
  let {
    translate,
    lang,
    data,
    label
  } = _ref8;
  const [value, setValue] = (0, _react.useState)({
    id: '',
    label: ''
  });
  const [selected, setSelected] = (0, _react.useState)({});
  const [sections, setSections] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    setSections(Object.entries(data).map(_ref9 => {
      let [key, value] = _ref9;
      return {
        id: value.id,
        label: key
      };
    }).sort((a, b) => {
      if (a.id === 0) return -1; // Place 0 at the beginning
      if (b.id === 0) return 1; // Place 0 at the beginning
      return a.label.localeCompare(b.label);
    }));
  }, [data]);
  (0, _react.useEffect)(() => {
    if (sections.length > 0) setValue(sections[0]);
  }, [sections]);
  (0, _react.useEffect)(() => {
    if (data && value?.label) setSelected(data[value.label]);
  }, [value]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-delegates-item"
  }, /*#__PURE__*/_react.default.createElement(TopContent, {
    selected: selected,
    value: value,
    setValue: setValue,
    translate: translate,
    sections: sections,
    lang: lang,
    label: label
  }), /*#__PURE__*/_react.default.createElement(BottomContent, {
    selected: selected,
    value: value,
    setValue: setValue,
    translate: translate
  }));
};
const InAppDelegates = _ref10 => {
  let {
    translate,
    lang,
    data
  } = _ref10;
  const data_professional_groups = Object.fromEntries(Object.entries(data.data_professional_groups).filter(el => Object.keys(el[1]?.stats || {}).length > 2).sort((a, b) => {
    return a[0].localeCompare(b[0]);
  }));
  const getGlobalStats = data => {
    const globalStats = {};
    for (const group in data) {
      for (const stat in data[group].stats) {
        if (!globalStats[stat]) {
          globalStats[stat] = [{
            total_men: 0,
            total_women: 0
          }];
        }
      }
    }
    for (const group in data) {
      const stats = data[group].stats;
      for (const stat in stats) {
        if (stat === 'professional_group_stats') {
          globalStats[stat][0].total_men += stats[stat][0].total_men;
          globalStats[stat][0].total_women += stats[stat][0].total_women;
        } else {
          globalStats[stat][0].total_men += stats[stat][0].total_men;
          globalStats[stat][0].total_women += stats[stat][0].total_women;
        }
      }
    }
    return globalStats;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-delegates-container sia-padding-05-bottom sia-margin-02-bottom"
  }, /*#__PURE__*/_react.default.createElement(InAppDelegatesItem, {
    data: data.data_sections,
    label: "cms.inapp.delegates.section",
    translate: translate,
    lang: lang
  }), /*#__PURE__*/_react.default.createElement(InAppDelegatesItem, {
    data: {
      [translate('cms.inapp.delegates.professional-groups.global')]: {
        id: 0,
        stats: getGlobalStats(data_professional_groups)
      },
      ...data_professional_groups
    },
    label: "cms.inapp.delegates.professional-groups",
    translate: translate,
    lang: lang
  }));
};
var _default = exports.default = InAppDelegates;